import { atomWithStorage } from 'jotai/utils';

/**
 * 選択済みプロジェクトIDをローカルストレージで管理する atom
 */
export const selectedProjectIdsAtom = atomWithStorage<string[]>(
  'vehicles_selected_project_ids',
  [],
);
